
import React, { useState } from 'react';
import Minus from '../../assets/imgs/minus.svg';
import Plus from '../../assets/imgs/plus.svg';
const ToggleList = ({ title, items }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleList = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='toggle-item'>
            <div className='toggle-btn' onClick={toggleList}>
                <h2>{title}</h2>
                {isOpen ? <img alt='insigne' src={Minus}></img> : <img alt='insigne' src={Plus}></img>}
            </div>
            {isOpen && (
                <ul>
                    {items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ToggleList;